import { render, staticRenderFns } from "./RecommendedItemsToTransfer.vue?vue&type=template&id=29f3ccc4&scoped=true"
import script from "./RecommendedItemsToTransfer.vue?vue&type=script&lang=js"
export * from "./RecommendedItemsToTransfer.vue?vue&type=script&lang=js"
import style0 from "./RecommendedItemsToTransfer.vue?vue&type=style&index=0&id=29f3ccc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3ccc4",
  null
  
)

export default component.exports